import type { ApplicationStatus } from '../fixtures/domain.js';
import { Icon } from '../components/Icon.js';
import { badgeStyle, statusBadgeOf } from './stageMeta.js';
import styles from './HiringStatusPill.module.css';

/**
 * Read-only badge for the hiring decision. Two homes: an ended chat shows its
 * outcome instead of offering moves, and a live one shows the stage it has
 * reached beside the control offering the next. One drawing either way, so a
 * chat's stage does not change appearance at the moment it closes.
 *
 * Degrades to a neutral "Chat ended" when no decision was recorded, which only
 * an ended chat can be: a live pipeline chat at "pending" renders no pill at all
 * rather than one saying nothing has happened yet.
 */
export function HiringStatusPill({
  status,
  compact,
}: {
  status: ApplicationStatus;
  /** One size down, for the widget header. See `.compact`. */
  compact?: boolean;
}) {
  const badge = statusBadgeOf(status);
  if (!badge) {
    return <span className={styles.neutral}>Chat ended</span>;
  }

  return (
    <span
      className={compact ? `${styles.pill} ${styles.compact}` : styles.pill}
      style={badgeStyle(badge.token)}
    >
      <Icon name={badge.icon} size={compact ? 13 : 14} filled={badge.filled} />
      {badge.label}
    </span>
  );
}
